/**
 * 腾讯云cos图片处理
 * 文档链接：https://cloud.tencent.com/document/product/436/44881
 * 缩放 @param {scale}
 * 质量变换 @param {quality}
 * 图片格式转换 @param {format}
 * 支持自定义传参数 @param {rule}
 * e.g. 自定义缩放裁剪
 * rule: /crop/<Width>x<Height>
 */
export const imgOptimize = (
  url: string,
  scale?: string | number,
  quality?: string | number,
  format = 'webp',
  rule?: string
) => {
  if (url && url.indexOf('imageMogr2') !== -1) return url
  const sign = url && url.indexOf('?') !== -1 ? '&' : '?'

  const imgUrl = url
    ? `${url}${sign}imageMogr2${scale ? `/thumbnail/${scale}` : ''}${
        quality ? `/quality/${quality}` : ''
      }${format ? `/format/${format}` : ''}${rule ? `${rule}` : ''}`
    : ''

  return imgUrl
}
